<template>
    <div class="step-container">
        <p class="step-title">{{title}}</p>
        <p class="step-sub-title">{{subTitle}}</p>
        <img class="step-img" :src="img"/>
    </div>
</template>

<script>
export default {
    name: 'StepComponent',
    props: {
        title: {
            type: String,
            default: ''
        },
        subTitle: {
            type: String,
            default: ''
        },
        img: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped lang="less">
.step-container {
    text-align: center;
    .step-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #F7B500;
        line-height: 24px;
    }
    .step-sub-title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 20px;
    }
    .step-img {
        width: 245px;
    }
}
</style>
